<template>
  <div class="user-batch">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ $t('userBatch.title') }}</span>
        <el-button type="primary" size="small" @click="handleAdd">{{ $t('userBatch.addBatch') }}</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" :label="$t('userBatch.colId')" width="70"></el-table-column>
        <el-table-column prop="name" :label="$t('userBatch.colName')"></el-table-column>
        <el-table-column prop="description" :label="$t('userBatch.colDesc')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="batch_start_date" :label="$t('userBatch.colStart')" width="120">
          <template slot-scope="scope">
            {{ scope.row.batch_start_date ? scope.row.batch_start_date.substring(0, 10) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_weeks" :label="$t('userBatch.colTotalWeeks')" width="80"></el-table-column>
        <el-table-column prop="members_count" :label="$t('userBatch.colMembers')" width="80"></el-table-column>
        <el-table-column :label="$t('userBatch.colAction')" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">{{ $t('userBatch.edit') }}</el-button>
            <el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row)">{{ $t('userBatch.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getList, deleteBatch } from '@/api/userBatch'

export default {
  name: 'UserBatch',
  data() {
    return {
      list: [],
      loading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 加载批次列表
    loadData() {
      this.loading = true
      getList().then(res => {
        this.list = res.data || []
      }).catch(() => {
        this.$message.error(this.$t('userBatch.loadFail'))
      }).finally(() => {
        this.loading = false
      })
    },
    // 新增批次
    handleAdd() {
      this.$router.push('/user-batch/edit')
    },
    // 编辑批次
    handleEdit(row) {
      this.$router.push('/user-batch/edit/' + row.id)
    },
    // 删除批次
    async handleDelete(row) {
      try {
        await this.$confirm(this.$t('userBatch.deleteConfirm'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
        deleteBatch(row.id).then(() => {
          this.$message.success(this.$t('userBatch.deleteSuccess'))
          this.loadData()
        }).catch(() => {
          this.$message.error(this.$t('userBatch.deleteFail'))
        })
      } catch (e) {
        // 取消删除
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}
</style>
